export const domains = {
    DOMAIN_STAGING: 'staging-0xproject.s3-website-us-east-1.amazonaws.com',
    DOMAIN_DOGFOOD: 'dogfood.0xproject.com',
    DOMAINS_DEVELOPMENT: ['0xproject.localhost:3572', 'localhost:3572', '127.0.0.1', '0.0.0.0:3572'],
    DOMAIN_PRODUCTION: 'governance.0xprotocol.org',
};
